import classNames from 'classnames'
import React from 'react'
import { connect } from 'react-redux'

import { hideToastAction, ToastState } from 'redux/ducks/toast'
import { ErrorType } from 'types'

export class Toast extends React.Component<ToastProps, any> {
  constructor(props) {
    super(props)
  }

  render() {
    const { alertComponent, toast, hideToast } = this.props
    const { visible, position, closable, alert } =
      toast || { visible: null, position: null, closable: null, alert: null}
    const toastClasses = classNames(
      'Alert--toast',
      position && `Alert--toast--${  position}`,
    )
    return React.createElement(alertComponent, {
      className: toastClasses,
      alert: visible && alert,
      closable,
      onClose: hideToast,
    })
  }
}
type ToastProps = {
  alertComponent: React.ComponentType<{
    className: string,
    alert?: ErrorType,
    closable: boolean,
    onClose: (...args) => any,
  }>,
  toast: ToastState,
  hideToast: () => void,
}
const mapStateToProps = (state, ownProps) => {
  return {
    toast: state.toast as ToastState,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    hideToast: () => dispatch(hideToastAction()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Toast)
